import * as React from 'react';

import 'css!./__styles__/DropdownMenu';

// AI-Generated Documentation - Please Read with Caution

type Value = string;
type Props = {
  /** Event handler called when the selected option changes */
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  /** Array of options to display in the dropdown */
  options: Array<{ label: string | JSX.Element; value: Value }>;
  /** Pre-selected value when component first renders */
  defaultValue?: Value;
  /** Currently selected value (for controlled components) */
  value?: Value;
  /** Optional text label displayed above the dropdown */
  label?: string;
  /** Additional props to pass to the select element */
  selectProps?: React.SelectHTMLAttributes<HTMLSelectElement> & {
    'data-e2e'?: string;
  };
};

/** A dropdown select menu component with configurable options and label. */
class DropdownMenu extends React.Component<Props> {
  render() {
    return (
      <div className="dropdown-list">
        {this.props.label && <span>{this.props.label}</span>}
        <select
          className="form-control"
          onChange={this.props.onChange}
          // @ts-expect-error TS2532 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
          defaultValue={this.props.defaultValue || this.props.options[0].value}
          value={this.props.value}
          {...this.props.selectProps}
        >
          {this.props.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default DropdownMenu;
